import {
	type DataFromDetails,
	fromDetails,
} from 'maps/services/dto/fromDetails'
import { ENDPOINT_STORES_FINDER } from 'maps/utils/constants'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { fetcher } from 'services/rest/fetcher'
import useSWRImmutable from 'swr/immutable'

const STORE_ID_LENGTH = 8
const STORE_ID_FILLER = '0'

interface UseStoreDeTailProps {
	storeId: string | null
}

export const useStoreDetail = ({ storeId }: UseStoreDeTailProps) => {
	const {
		channel,
		country: { countryISO, languageISO },
	} = useMasterData()

	const fullStoreId = storeId?.padStart(STORE_ID_LENGTH, STORE_ID_FILLER)

	const basePath = `${ENDPOINT_STORES_FINDER}/${fullStoreId}`
	const searchParams = new URLSearchParams({
		language: languageISO.toUpperCase(),
		country: countryISO,
		channel,
	})

	const url = new URL(basePath, process.env.NEXT_PUBLIC_SITE_BASE_URL)
	url.search = searchParams.toString()

	const fetchUrl = url.href

	const { data, isLoading, mutate, error } = useSWRImmutable<{
		stores: DataFromDetails[]
	}>(storeId ? fetchUrl : null, fetcher)

	return {
		data: data && fromDetails(data.stores[0]),
		isLoading,
		mutate,
		error,
	}
}
